import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";
import { MENU_IDS } from "./constant";
import { createEntitySelectors } from "../utils/createEntitySelectors";
import { TAppMenu, TMenuIds } from "./types";

export const selectMenuState = (state: RootState) => state.menuState;

export const selectAppMenus = createSelector(
  selectMenuState,
  (state) => state.appMenu,
);

export const menuSelectors = createEntitySelectors<TAppMenu, TMenuIds>(
  selectAppMenus,
  MENU_IDS,
);
